import { Text, Grid, Flex } from "@radix-ui/themes";
import cx from "classnames";

interface PasswordStrength {
  score: number;
  suggestions: string[];
}

interface Props {
  strength: PasswordStrength;
  showInitialRequirements?: boolean;
}

export function PasswordRequirements({
  strength,
  showInitialRequirements = false,
}: Props) {
  if (showInitialRequirements) {
    return (
      <Grid gap="2">
        <Text size="2" className="text-puntt-neutral-gray-11">
          Password requirements:
        </Text>
        <Grid gap="1">
          <Text size="1" className="text-puntt-neutral-gray-11">
            • At least 10 characters long
          </Text>
          <Text size="1" className="text-puntt-neutral-gray-11">
            • Must not be a common or{" "}
            <a
              href="https://haveibeenpwned.com/Passwords"
              target="_blank"
              rel="noopener noreferrer"
            >
              breached password
            </a>{" "}
            (we check against known data breaches)
          </Text>
          <Text size="1" className="text-puntt-neutral-gray-11">
            • Avoid common words, repeated characters, or simple patterns
          </Text>
        </Grid>
      </Grid>
    );
  }

  const passwordStrengthText = strength.score < 3 ? "Weak" : "Strong";

  return (
    <Grid gap="2">
      <Flex align="center" gap="2">
        <Text
          size="2"
          className={cx({
            "text-puntt-gold-dark-8": strength.score < 3,
            "text-puntt-blue-10": strength.score >= 3,
          })}
        >
          Password Strength: {passwordStrengthText}
        </Text>
      </Flex>
      {strength.suggestions.map((suggestion, index) => (
        <Flex key={index} align="center" gap="2">
          <Text size="1" className="text-puntt-gold-dark-8">
            {suggestion}
          </Text>
        </Flex>
      ))}
    </Grid>
  );
}
